<script>
import AppDisplay from '@/components/AppDisplay.vue'
import { formataStringYearMonthToBr } from '@/utils/utils'
import { opcoesTipoSistemaIrrigacao, opcoesFonteAguaUtilizada, opcoesCaptacaoLicenciada } from '@/libs/constants/praticas/opcoesSelects'

export default {
  components: {
    AppDisplay
  },
  props: {
    irrigacao: {
      type: Object
    }
  },
  methods: {
    formataStringYearMonthToBr,
    formataTiposSistemas (values) {
      if (!values || !values.length) return ''
      const tiposFormatados = values.filter(value => value !== 'OUTRO')
      return tiposFormatados.map(tipoSistema => opcoesTipoSistemaIrrigacao.find(opcao => opcao.id === tipoSistema).nome).join(', ')
    },
    formataFontesAgua (values) {
      if (!values || !values.length) return ''
      const fontesFormatadas = values.filter(value => value !== 'OUTRO')
      return fontesFormatadas.map(fonteAgua => opcoesFonteAguaUtilizada.find(opcao => opcao.id === fonteAgua).nome).join(', ')
    },
    formataCaptacaoLicenciada (value) {
      if (!value) return ''
      return opcoesCaptacaoLicenciada.find(opcao => opcao.id === value)?.nome
    }
  }
}
</script>

<template>
  <div>
    <div class="mt-2">
      <span class="title-praticas">Dados da irrigação</span>
      <hr />
    </div>
    <el-row v-if="!irrigacao.possuiIrrigacao">
      <el-col :span="12">
        <app-display label="Possui sistemas irrigados ou sistema fertirrigação?" content="Não" />
      </el-col>
    </el-row>
    <el-row v-else>
      <el-col :span="12">
        <app-display label="Possui sistemas irrigados ou sistema fertirrigação?" content="Sim" />
        <app-display label="Área irrigada (em hectares):" :content="irrigacao.area" />
        <app-display label="Data de início da irrigação (mês/ano):" :content="formataStringYearMonthToBr(irrigacao.dataInicio)" />
        <app-display label="Tipo de sistema:" :content="formataTiposSistemas(irrigacao.tiposSistemas)" />
        <app-display v-if="irrigacao.tiposSistemas.length && irrigacao.tiposSistemas.includes('OUTRO')" label="Outros tipo de sistema:" :content="irrigacao.outroSistema" />
      </el-col>
      <el-col :span="12">
        <app-display label="Fonte de água utilizada:" :content="formataFontesAgua(irrigacao.fontesAgua)" />
        <app-display v-if="irrigacao.fontesAgua.length && irrigacao.fontesAgua.includes('OUTRO')" label="Outras fonte de água:" :content="irrigacao.outroFonteAgua" />
        <app-display label="Captação licenciada?" :content="formataCaptacaoLicenciada(irrigacao.captacaoLicenciada)" />
        <app-display label="Qual a quantidade de água anual utilizada?" :content="`${irrigacao.quantidadeAguaAnual} m³`" />
      </el-col>
    </el-row>
  </div>
</template>

<style lang="scss" scoped>
  @import '../style.scss'
</style>



// WEBPACK FOOTER //
// src/components(new)/UI/Modals/VisualizacaoCadastro/Cadastro/Praticas/components/Irrigacao.vue